import { defineStore } from 'pinia';

// Funções simples pra ler e escrever cookie
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/;Secure;SameSite=Lax`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i=0; i < ca.length; i++) {
    let c = ca[i];
    while(c.charAt(0) == ' ') c = c.substring(1,c.length);
    if(c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: null,
    checkingSession: false,
    me: null, // Adicionei um estado para armazenar os dados do usuário autenticado
  }),
  actions: {
    setAccessToken(token) {
      this.accessToken = token;
      setCookie('access_token', token, 1); // salva cookie 1 dia
    },
    loadAccessTokenFromCookie() {
      const token = getCookie('access_token');
      if (token) {
        this.accessToken = token;
      }
    },
    clearAccessToken() {
      this.accessToken = null;
      setCookie('access_token', '', -1); // apaga cookie
    },
    logout() {
      this.clearAccessToken()
      this.me = null; // Limpa os dados do usuário autenticado
      // Aqui você pode adicionar lógica de logout, como redirecionar ou limpar outros estados
    },
    async checkSession() {
      console.log('Verificando sessão...', this.checkingSession);
      if (this.checkingSession) {
        console.log('Já está verificando a sessão, aguardando...');
        return; // Já está verificando, não faz nada  
      }
      this.checkingSession = true;
      this.loadAccessTokenFromCookie(); // Carrega o token do cookie
      if (!this.accessToken) {
        console.log('Nenhum token encontrado, não é necessário verificar a sessão');
        this.checkingSession = false;
        return; // Se não tiver token, não precisa verificar a sessão
      }
      const headers = {
        Authorization: this.accessToken ? `Bearer ${this.accessToken}` : '',
        'Content-Type': 'application/json',
      }

      const resAuth = await fetch('https://api.reportmap.app/webhook/reportmap/auth', {
        method: 'POST',
        headers,
      }).then(res => {
        if (!res.ok) {
          throw new Error('Erro ao verificar sessão');
        }
        return res.json();
      }).catch(err => {
        console.error('Erro ao verificar sessão:', err);
        return { valid: false }; // Assume que a sessão não é válida se houver erro
      }).finally(() => {
        this.checkingSession = false;
        console.log('Verificação de sessão concluída');
      });

      this.me = resAuth || null; // Armazena os dados do usuário autenticado

      // Interceptor de resposta
      if (resAuth.status === 401) {
        this.logout() // ou redireciona
        throw new Error('Não autorizado')
      }
    }
  }
});
